import { configUiPanel_mobile_vertical as  configUiPanel_default} from "src/library/minigame_client/ui/panel"

export let configUiPanel_mobile_horizontal = _.cloneDeep(configUiPanel_default);

const resourcesUiPanel_mobile_horizontal = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            "res/common/minigames/sounds/btn_click",
            "res/common/minigames/sounds/play_click",
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/common/minigames/panel/mobile_horizontal/common.json",
            {name: "res/common/minigames/panel/mobile_horizontal/panel.json", rus: true},

            "res/common/minigames/panel/mobile_vertical/fonts/font_bet_panel_mobile_vertical.xml",
            "res/common/minigames/panel/mobile_vertical/fonts/font_bet_light_panel_mobile_vertical.xml",
            "res/common/minigames/panel/mobile_vertical/fonts/font_credits_panel_mobile_vertical.xml",
            "res/common/minigames/panel/mobile_vertical/fonts/font_currency_panel_mobile_vertical.xml",
            "res/common/minigames/panel/mobile_vertical/fonts/font_currency_bet_panel_mobile_vertical.xml",
        ]
};

configUiPanel_mobile_horizontal.resources = resourcesUiPanel_mobile_horizontal;
configUiPanel_mobile_horizontal.packFolder = "minigames_panel_mobile_horizontal/";
configUiPanel_mobile_horizontal.sndBtnClick = "res/common/minigames/sounds/btn_click";
configUiPanel_mobile_horizontal.sndBtnPlay = "res/common/minigames/sounds/play_click";
configUiPanel_mobile_horizontal.screenWidth = 900;
configUiPanel_mobile_horizontal.screenHeight = 540;
configUiPanel_mobile_horizontal.isMobileMode = true;                                 // if false - not need res folders digital_panel
configUiPanel_mobile_horizontal.isAccumulateBetMode = true;                          // if false - not need res folders 2div, 2mul, clear, if true - not need light texture in folders bet, min_bet, max_bet
configUiPanel_mobile_horizontal.isNoMinMaxButtons = false;                           // if false - not need res folders min_bet, max_bet
configUiPanel_mobile_horizontal.isHideTotalBet = false;                              // если нужно скрыть валюту и ставку и выводить ее иначе
configUiPanel_mobile_horizontal.isHideCurrencyCredits = false;                       // если нужно скрыть валюту кредитов
configUiPanel_mobile_horizontal.balanceTabPosition = {x: 200, y: 9};
configUiPanel_mobile_horizontal.buttonPlaceBetTextPos = {x: 72, y: 62};
configUiPanel_mobile_horizontal.buttonPlaceBetPosition = {x: 725, y: 260};
configUiPanel_mobile_horizontal.buttonClearTotalBetPosition = {x: 465, y: 13};
configUiPanel_mobile_horizontal.buttonDivPosition = {x: 49, y: 221};
configUiPanel_mobile_horizontal.buttonMulPosition = {x: 298, y: 221};
configUiPanel_mobile_horizontal.buttonMinPosition = {x: 104, y: 363};
configUiPanel_mobile_horizontal.buttonMaxPosition = {x: -1, y: 363};
configUiPanel_mobile_horizontal.widthTotalBetTextArea = 127;
configUiPanel_mobile_horizontal.widthCreditsTextArea = 140;
configUiPanel_mobile_horizontal.widthBetButtonTextArea = 63;                         // ширина области для вывода текста(для скалирования текста если не помещается)
configUiPanel_mobile_horizontal.lengthAreaForBetsButtons = 533;                      // ширина(высота) области для размещения кнопок ставок(скалирование кнопок для заполнения всей области)
configUiPanel_mobile_horizontal.lengthBetButton = 81;                                // ширина(высота) кнопки
configUiPanel_mobile_horizontal.offsetBetweenBetButtons = 0;                         // отступ между кнопками
configUiPanel_mobile_horizontal.startBetButtonsPos = {x: 1, y: 462};                 // координаты первой кнопки
configUiPanel_mobile_horizontal.isVerticallyDirection = true;                        // вертикально или горизонтально идут кнопки

configUiPanel_mobile_horizontal.labelCredits = {
    pos: {x: 74, y: 33},
    font: {
        name: "font_credits_panel_mobile_vertical"
    }
};
configUiPanel_mobile_horizontal.labelCurrencyCredits = {
    pos: {x: 85, y: 1},
    font: {name: "font_currency_panel_mobile_vertical"}
};
configUiPanel_mobile_horizontal.labelTotalBet = {
    pos: {x: 762, y: 42},
    font: {name: "font_credits_panel_mobile_vertical"}
};
configUiPanel_mobile_horizontal.labelCurrencyTotalBet = {
    pos: {x: 743, y: 6},
    font: {
        name: "font_currency_panel_mobile_vertical",
        align: "left",
        anchor: {x: 0.0, y: 0.0},
        tint: 0x000000
    }
};
configUiPanel_mobile_horizontal.labelBetButton = {
    pos: {x: 41, y: 29},
    font: {name: "font_bet_panel_mobile_vertical"}
};
configUiPanel_mobile_horizontal.labelBetLight = {
    pos: {x: 41, y: 29},
    font: {name: "font_bet_light_panel_mobile_vertical"}
};


// WEBPACK FOOTER //
// ./src/library/minigame_client/ui/cfg/mobile_horizontal/panel.es6